import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import DragCard from './drag_card';

// 单项选择题
class DragContainer extends Component {
  // 参数
  static propTypes = {
    questionId: PropTypes.number.isRequired,
    answer: PropTypes.array.isRequired,
    choices: PropTypes.array.isRequired,
    handleAnswer: PropTypes.func.isRequired,
  };

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      answer: [],
    };
  }

  // 模块加载
  componentDidMount() {
    this.setState({ answer: this.props.answer });
  }

  // 更新
  componentWillReceiveProps(nextProps) {
    if (this.props.questionId !== nextProps.questionId) {
      this.setState({ answer: nextProps.answer });
    }
  }

  // 拖拽触发事件
  handleDndHover = (dragIndex, hoverIndex) => {
    const { answer } = this.state;
    const tmp = answer[dragIndex]; // 临时储存文件
    answer.splice(dragIndex, 1); // 移除拖拽项
    answer.splice(hoverIndex, 0, tmp); // 插入放置项
    this.setState({ answer });
  }

  handleDndEnd = () => {
    this.props.handleAnswer(this.state.answer);
  }

  // 渲染
  render() {
    const { choices } = this.props;
    const { answer } = this.state;
    return (
      <div>
        {
          answer.map((item, index) => (
            <DragCard
              key={item}
              index={index}
              content={choices[item].text}
              handleDndHover={this.handleDndHover}
              handleDndEnd={this.handleDndEnd}
            />
          ))
        }
      </div>
    );
  }
}

export default DragDropContext(HTML5Backend)(DragContainer);



// WEBPACK FOOTER //
// ./src/components/questions/sort/drag_container.js